import PropTypes from 'prop-types'
import React, { createRef } from 'react'
import onClickOutside from 'react-onclickoutside'

import YearDropdownOptions from './YearDropdownOptions'

const WrappedYearDropdownOptions = onClickOutside(YearDropdownOptions)

class YearDropdown extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      dropdownVisible: false
    }
    this.dropdownRef = createRef()
  }

  renderSelectOptions = () => {
    const minYear = this.props.minDate ? this.props.minDate.year() : 1900
    const maxYear = this.props.maxDate ? this.props.maxDate.year() : 2100

    const options = []
    for (let i = minYear; i <= maxYear; i++) {
      options.push(
        <option
          key={i}
          value={i}
        >
          {i}
        </option>
      )
    }
    return options
  }

  onSelectChange = e => {
    this.onChange(e.target.value)
  }

  renderSelectMode = () => (
    <select
      value={this.props.year}
      className='react-datepicker__year-select'
      onChange={this.onSelectChange}
    >
      {this.renderSelectOptions()}
    </select>
  )

  renderReadView = visible => (
    <button
      key='read'
      style={{ visibility: visible ? 'visible' : 'hidden' }}
      className='react-datepicker__year-read-view'
      onClick={this.toggleDropdown}
    >
      <span className='react-datepicker__year-read-view--down-arrow' />
      <span className='react-datepicker__year-read-view--selected-year'>
        {this.props.year}
      </span>
    </button>
  )

  renderDropdown = () => (
    <WrappedYearDropdownOptions
      key='dropdown'
      ref={this.dropdownRef}
      year={this.props.year}
      onChange={this.onChange}
      onCancel={this.toggleDropdown}
      scrollableYearDropdown={this.props.scrollableYearDropdown}
    />
  )

  renderScrollMode = () => {
    const { dropdownVisible } = this.state
    const result = [ this.renderReadView(!dropdownVisible) ]
    if (dropdownVisible) {
      result.unshift(this.renderDropdown())
    }
    return result
  }

  onChange = year => {
    this.toggleDropdown()
    if (year === this.props.year) {
      return
    }
    this.props.onChange(year)
  }

  toggleDropdown = () => {
    this.setState(s => ({
      dropdownVisible: !s.dropdownVisible
    }))
  }

  render () {
    let renderedDropdown
    switch (this.props.dropdownMode) {
      case 'scroll':
        renderedDropdown = this.renderScrollMode()
        break
      case 'select':
        renderedDropdown = this.renderSelectMode()
        break
      default:
        break
    }

    return (
      <div
        className={`react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--${this.props.dropdownMode}`}
      >
        {renderedDropdown}
      </div>
    )
  }
}

YearDropdown.displayName = 'YearDropdown'

YearDropdown.propTypes = {
  dropdownMode: PropTypes.oneOf([ 'scroll', 'select' ]).isRequired,
  maxDate: PropTypes.instanceOf(Object),
  minDate: PropTypes.instanceOf(Object),
  onChange: PropTypes.func.isRequired,
  scrollableYearDropdown: PropTypes.bool,
  year: PropTypes.number.isRequired
}

export default YearDropdown
